<template>
  <footer>
    <cookie-law buttonText="Rendben">
      <div slot="message">
        Az oldal sütiket használ működéséhez. Az oldal használatával hozzájárul, hogy az sütiket tárolhat számítógépén.
        <a download target="_blank" href="https://vali.hu/static/cookie_tajekoztato.pdf">
          Süti tájékoztató
        </a>
      </div>
    </cookie-law>
  </footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
export default {
  components: { CookieLaw }
}
</script>

<style>
.Cookie--base .Cookie__button {
  background-color: var(--color-green);
  border-radius: 8px;
}

.Cookie--base .Cookie__button:hover {
  background-color: var(--color-darkgreen);
}
</style>
